import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TabAction, TabItem } from './tabs.interface';

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent {
  @Input() tabs: TabItem[] = [];
  @Input() activeTab: string = '';
  @Input() tabIdPrefix: string = '';
  @Input() containerClass?: string = '';
  @Input() showActions: boolean = true;
  @Input() actions?: TabAction[] = [];
  
  @Output() tabSelected = new EventEmitter<string>();

  selectTab(tabKey: string) {
    this.tabSelected.emit(tabKey);
  }
}